export const convertImgToBase64URL = (url) => new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
        let canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL());
        canvas = null;
    };
    img.onerror = () => {
        reject(new Error(`Could not convert "${url}" to data URL.`));
    };
    img.src = url;
});
